if (!customElements.get('product-form')) {
  const PRODUCT_FORM_ERROR_STYLE_ID = 'product-form-error-message-style';

  function ensureProductFormErrorStyles() {
    if (document.getElementById(PRODUCT_FORM_ERROR_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = PRODUCT_FORM_ERROR_STYLE_ID;
    style.textContent = [
      '.product-form__error-message-wrapper{',
      'display:flex;align-items:flex-start;gap:.6rem;width:100%;',
      'margin-top:.8rem;padding:.8rem 1rem;box-sizing:border-box;',
      'font-size:1.3rem;line-height:1.4;text-align:left;',
      'color:#93000B;',
      'border:1px solid currentColor;border-radius:var(--inputs-radius,.4rem);',
      'background:rgba(147,0,11,.06);}',
      '.product-form__error-message-wrapper[hidden]{display:none;}',
      '.product-form__error-message-wrapper::before{',
      "content:'!';flex:0 0 auto;width:1.6rem;height:1.6rem;",
      'display:inline-flex;align-items:center;justify-content:center;',
      'border-radius:50%;border:1px solid currentColor;',
      'font-size:1.1rem;font-weight:700;line-height:1;}',
      '.product-form__error-message{flex:1 1 auto;min-width:0;}',
    ].join('');

    document.head.appendChild(style);
  }

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.itemsSuppliers = [];
        this.onSubmit = this.onSubmitHandler.bind(this);
      }

      connectedCallback() {
        this.bind();
      }

      morphedCallback() {
        this.bind();
      }

      bind() {
        const form = this.querySelector('form');
        if (!form) return;

        this.form = form;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.hideErrors = this.dataset.hideErrors === 'true';

        this.errorMessageWrapper = null;
        this.errorMessage = null;

        const variantIdInput = this.variantIdInput;
        if (variantIdInput) variantIdInput.disabled = false;

        if (this.submitButton && document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        if (form.dataset.submitBound === 'true') return;
        form.addEventListener('submit', this.onSubmit);
        form.dataset.submitBound = 'true';
      }

      get spinner() {
        return this.querySelector('.loading__spinner');
      }

      get cartComponent() {
        const cart = this.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart) return null;
        if (typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') return null;
        this.cart = cart;
        return cart;
      }

      registerItemsSupplier(supplier) {
        if (typeof supplier === 'function') this.itemsSuppliers.push(supplier);
      }

      getExtraItems() {
        return this.itemsSuppliers.flatMap((supplier) => {
          try {
            return supplier() || [];
          } catch (error) {
            console.error(error);
            return [];
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.spinner?.classList.remove('hidden');

        const formData = new FormData(this.form);
        formData.delete('product-final-price');
        if (!formData.get('selling_plan')) formData.delete('selling_plan');

        const cart = this.cartComponent;
        const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : null;
        if (cart) cart.setActiveElement(document.activeElement);

        const extraItems = this.getExtraItems();
        const cartEvent = this.dispatchLinesUpdate(formData, extraItems);
        let config;

        if (extraItems.length) {
          const line = {
            id: Number(formData.get('id')),
            quantity: Number(formData.get('quantity')) || 1,
          };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) line.selling_plan = Number(sellingPlan);

          const body = { items: [line, ...extraItems] };
          if (sections) {
            body.sections = sections;
            body.sections_url = window.location.pathname;
          }

          config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          };
        } else {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (sections) {
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              cartEvent.resolve({
                cart: null,
                userErrors: [
                  {
                    message: response.description || response.message || window.cartStrings.error,
                    code: response.status === 422 ? 'INVALID' : 'SERVICE_UNAVAILABLE',
                  },
                ],
              });
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            cartEvent.resolve({ cart: null, detail: { lineItems: Array.isArray(response.items) ? response.items : [response] } });

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productForm: this,
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            if (!cartEvent.settled) {
              cartEvent.reject(e);
              if (typeof breeqDispatchCartError === 'function') breeqDispatchCartError(this, e, 'SERVICE_UNAVAILABLE');
            }
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.spinner?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      dispatchLinesUpdate(formData, extraItems) {
        const noop = { promise: Promise.resolve(), settled: true, resolve() {}, reject() {} };
        if (typeof breeqDispatchCartEvent !== 'function') return noop;

        const lines = [
          { merchandiseId: String(formData.get('id') || ''), quantity: Number(formData.get('quantity')) || 1 },
          ...extraItems.map(({ id, quantity }) => ({ merchandiseId: String(id), quantity: Number(quantity) || 1 })),
        ].filter((line) => line.merchandiseId !== '');
        if (!lines.length) return noop;

        const context = this.closest('dialog') ? 'dialog' : this.closest('cart-drawer') ? 'cart' : 'product';

        return breeqDispatchCartEvent(this, 'theme:cart:lines-update', { action: 'add', context, lines });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) {
          if (!errorMessage) return;
          this.errorMessageWrapper = this.buildErrorMessageWrapper();
          if (!this.errorMessageWrapper) return;
        }

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        if (!this.errorMessage) return;

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      buildErrorMessageWrapper() {
        ensureProductFormErrorStyles();

        const wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        wrapper.hidden = true;

        const text = document.createElement('span');
        text.className = 'product-form__error-message';
        wrapper.appendChild(text);

        if (this.form && this.form.parentNode) {
          this.form.insertAdjacentElement('afterend', wrapper);
        } else {
          this.appendChild(wrapper);
        }

        return wrapper;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
